import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "semantic-ui-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import CustomDropdown from "components/CustomDropdown";
import withRoleCheck from "components/hocs/withRoleCheck";
import _CaseFormModal from "./CaseFormModal";
import { UpdateCampaignCaseModal } from "./UpdateCampaignCaseModal";
import ConfirmationModal from "components/modals/ConfirmationModal";
import CaseService from "services/Case";

const CaseFormModal = withRoleCheck(_CaseFormModal, [
  ACL_RELATIONSHIPS.case.edit,
]);

const AddCaseToCampaignDropdownItem = withRoleCheck(Dropdown.Item, [
  // ACL_RELATIONSHIPS.adminUser.create,
]);

const ViewMapDropdownItem = withRoleCheck(Dropdown.Item, [
  ACL_RELATIONSHIPS.machine.read,
]);

export const CasesTableActions = ({
  caseId,
  caseData,
  fetchCases,
  campaignId,
}) => {
  const addToCampaignModalRef = useRef(null);
  const navigate = useNavigate();

  const checkCaseEntityValidity = () => {
    const isEntityValid = caseData.entity_id && caseData.entity_id !== 0;
    if (isEntityValid) {
      return { caseIds: [caseId], invalidCases: [] };
    } else {
      return {
        caseIds: [],
        invalidCases: [
          {
            id: caseData.id,
            name: caseData.name,
            case_id: caseData.case_id,
          },
        ],
      };
    }
  };

  const checkCampaignCaseExists = () => {
    if (!campaignId) return false;
    const matchCampaignId = c => c.campaign_id === parseInt(campaignId);
    const campaignCase = caseData.campaign_cases.find(matchCampaignId);
    return !!campaignCase;
  };

  const removeFromCampaign = async () => {
    await CaseService.removeCaseFromCampaign({
      case_ids: [caseId],
      campaign_id: parseInt(campaignId),
    });
    await fetchCases();
  };

  const handleAddToCampaign = () => {
    if (addToCampaignModalRef.current) {
      addToCampaignModalRef.current.open(checkCaseEntityValidity());
    }
  };

  return (
    <>
      <CustomDropdown icon="ellipsis horizontal">
        <Dropdown.Menu direction="left">
          <CaseFormModal caseId={caseId} fetchData={fetchCases} />
          <ViewMapDropdownItem
            content="Map"
            icon="map marker alternate"
            onClick={() => navigate(`/cases/${caseId}/map`)}
          />
          {(!campaignId || !checkCampaignCaseExists()) &&
            caseData.entity_id && (
              <AddCaseToCampaignDropdownItem
                content="Add To Campaign"
                icon="plus"
                onClick={handleAddToCampaign}
              />
            )}
          {campaignId && checkCampaignCaseExists() && (
            <ConfirmationModal
              menuTrigger
              icon="trash"
              actionDescription="Remove From Campaign"
              onConfirm={removeFromCampaign}
              popupPosition="right"
              warning
            >
              <p>Are you sure you want to remove this Case?</p>
            </ConfirmationModal>
          )}
        </Dropdown.Menu>
      </CustomDropdown>

      <UpdateCampaignCaseModal
        ref={addToCampaignModalRef}
        modalHeader={"Add Case to Campaign"}
        campaignId={campaignId}
        onSuccess={fetchCases}
      />
    </>
  );
};
